<template>
  <div>
    <el-dialog
      class="backdrop-blur"
      id="detect-dialog"
      top="10vh"
      width="550px"
      center
      :visible="DetectDialogObj.visible"
      @close="HandleCancel"
    >
      <span
        @click="CopyTextToClipboard(DetectDialogObj.bankCardNumber)"
        class="el-dialog__title"
        style="cursor: pointer"
        slot="title"
        >{{ DetectDialogObj.bankName }}「{{
          DetectDialogObj.bankCardNumber ? DetectDialogObj.bankCardNumber : ""
        }}
        <i class="el-icon-document-copy"></i>」<br />银行卡派单状态检测</span
      >
      <el-carousel
        ref="carousel"
        height="500px"
        arrow="never"
        :loop="false"
        :autoplay="false"
      >
        <el-carousel-item>
          <h3 class="medium">
            <div
              :class="{ dispatchStatusFinish: dispatchStatusFinish }"
              class="processingCon"
            ></div>

            <ul>
              <li
                v-for="(item, index) in detectList.list"
                :key="item.label"
                :style="`animation-delay: ${index / 10}s; padding-right: 30px`"
              >
                <!-- =========== 如果有推荐本金 start =========== -->
                <el-tooltip
                  v-if="item.alertMessage"
                  class="item"
                  effect="dark"
                  :content="item.alertMessage"
                  placement="left"
                >
                  <span>
                    {{ item.label }}
                    <SuccErrMark
                      :show-extend-value="item.extendValue"
                      :show="item.checkStatus"
                    />
                  </span>
                </el-tooltip>
                <!-- =========== 如果有推荐本金 end =========== -->

                <span v-else>
                  {{ item.label }}
                  <SuccErrMark
                    :show-text="
                      'status' in item ? (item.status ? '是' : '否') : ''
                    "
                    :show-extend-value="item.extendValue"
                    :show="item.checkStatus"
                  />
                </span>

                <!-- =========== 限额小箭头 start =========== -->
                <span
                  v-if="
                    item.label.includes('是否开启限额') &&
                    detectList.enableLimitExtend
                  "
                  @click="$refs.carousel.setActiveItem(1)"
                  ><i class="el-icon-d-arrow-right" />
                </span>
                <!-- =========== 限额小箭头 end =========== -->
              </li>

              <li
                v-if="detectList.list"
                :style="`animation-delay: ${
                  (detectList.list.length + 6) / 10
                }s; padding-right: 30px`"
              >
                <div><el-divider></el-divider></div>
                <span :style="`color: #${messageColor}`">{{
                  detectList.result
                }}</span>
              </li>
            </ul>
          </h3>
        </el-carousel-item>
        <el-carousel-item>
          <h3 class="medium">
            <ul v-if="detectList.enableLimitExtend">
              <li v-for="item in enableLimitExtendObj" :key="item.label">
                {{ item.label
                }}<span class="value-color">{{
                  detectList.enableLimitExtend[item.value]
                }}</span>
              </li>
              <li @click="$refs.carousel.setActiveItem(0)">
                <i class="el-icon-d-arrow-left" />
              </li>
            </ul>
          </h3>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { getDispatchStatus } from "@/api/account";
import SuccErrMark from "./SuccErrMark";
export default {
  mixins: [mainCommon],
  props: ["DetectDialogObj"],
  components: {
    SuccErrMark,
  },
  data() {
    return {
      detectList: {},
      dispatchStatusFinish: false,
      messageColor: "",
      enableLimitExtendObj: [
        {
          label: "每日收款限额：",
          value: "dailyPaymentLimit",
        },
        {
          label: "每日出款限额：",
          value: "dailyWithdrawalLimit",
        },
        {
          label: "最大收款限额：",
          value: "maxPaymentLimit",
        },
        {
          label: "最大出款限额：",
          value: "maxWithdrawalLimit",
        },
      ],
    };
  },
  watch: {
    DetectDialogObj: {
      handler: function (val) {
        if (val.visible) {
          this.getDispatchStatus(val.id);
        }
      },
      deep: true,
    },
  },
  methods: {
    getMessageColor() {
      if (this.detectList.result.includes("派单正常")) {
        this.messageColor = "f5ae44";
      } else if (this.detectList.result.includes("正在派单")) {
        this.messageColor = "7cff3b";
      } else if (this.detectList.result.includes("很遗憾")) {
        this.messageColor = "fd5555";
      } else {
        this.messageColor = "fd5555";
      }
    },
    getDispatchStatus(id) {
      getDispatchStatus(id)
        .then((res) => {
          this.$refs.carousel.setActiveItem(0);
          this.detectList = res.data;
          this.getMessageColor();

          setTimeout(() => {
            this.dispatchStatusFinish = true;
          }, 1000);
        })
        .catch(() => {})
        .finally(() => {});
    },
    HandleCancel() {
      this.dispatchStatusFinish = false;
      this.$refs.carousel.setActiveItem(0);
      this.$emit("update:detect-dialog-obj", { visible: false });
    },
  },
};
</script>
<style scoped>
/* start 透明化 */
#detect-dialog /deep/ .el-dialog {
  background-color: transparent;
  box-shadow: none;
}
#detect-dialog /deep/ .el-dialog__title {
  color: #fff;
  text-shadow: 0px 0px 6px #000000c4;
  font-weight: 600;
}
#detect-dialog /deep/ .el-dialog__close {
  color: #fff;
}
/* end 透明化 */

.el-carousel__item h3 {
  padding: 0 30px;
  color: #fff;
  text-shadow: 0px 0px 3px #000000c4;
}
#detect-dialog /deep/ .el-carousel__indicators {
  display: none;
}
.value-color {
  color: #ffa600;
  text-shadow: 0px 0px 2px #000;
}
ul li {
  padding: 0;
  margin: 0 0 16px 0;
  list-style-type: none;
  opacity: 0;
  animation: fade-in 0.3s ease forwards;
  margin-top: -10px;
  font-size: 17px;
  font-weight: 600;
  position: relative;
}
@keyframes fade-in {
  0% {
    margin-top: -10px;
  }
  100% {
    opacity: 1;
    margin-top: 0;
  }
}

.processingCon {
  top: 50%;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  height: 2px;
  background-color: #ddd;
  border-radius: 4px;
  line-height: 2em;
  animation: progressCon 0.2s forwards;
  opacity: 0;
  margin-top: -10px;
  margin-left: 20px;
}
@keyframes progressCon {
  0% {
    margin-top: -10px;
  }
  100% {
    opacity: 1;
    margin-top: 0px;
  }
}

/* 接口资讯回传完成 */
.dispatchStatusFinish {
  animation: progressFinish 0.2s forwards;
}
@keyframes progressFinish {
  0% {
    opacity: 1;
    margin-top: 0px;
  }
  100% {
    opacity: 0;
    margin-top: -10px;
  }
}

.processingCon:before {
  position: relative;
  background: #39b828;
  animation: progress 0.6s infinite;
  border-radius: 4px;
  display: block;
  content: "";
  height: 2px;
  opacity: 0;
  width: 10%;
}

@keyframes progress {
  0% {
    opacity: 1;
    left: 0;
  }
  50% {
    left: 90%;
  }
  100% {
    opacity: 1;
    left: 0;
  }
}
.el-icon-d-arrow-right {
  font-size: 20px;
  font-weight: 600;
  margin-left: 10px;
  animation: arrowRight 1.2s infinite;
  opacity: 1;
  cursor: pointer;
  vertical-align: middle;
  color: #ffa600;
}
@keyframes arrowRight {
  0% {
    opacity: 1;
    margin-left: 10px;
  }
  50% {
    opacity: 0.3;
    margin-left: 20px;
    color: #ff6200;
  }
  100% {
    opacity: 1;
    margin-left: 10px;
  }
}
.el-icon-d-arrow-left {
  font-size: 20px;
  font-weight: 600;
  margin-left: 0;
  animation: arrowLeft 1.2s infinite;
  opacity: 1;
  cursor: pointer;
  vertical-align: middle;
  color: #ffa600;
}
@keyframes arrowLeft {
  0% {
    opacity: 1;
    margin-left: 0;
  }
  50% {
    opacity: 0.3;
    margin-left: 10px;
    color: #ff6200;
  }
  100% {
    opacity: 1;
    margin-left: 0;
  }
}
.backdrop-blur {
  backdrop-filter: blur(5px);
}
</style>


// WEBPACK FOOTER //
// src/views/components/dialog/DetectDialog.vue